//Smooth scroll START
$(function() {
	$('a[href*="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 200);
		return false;
		}
	}
	});
});
//Smooth scroll END

//Waypoints START
function waypoints() {
	$('.waypoint').each(function() {
		var thisOne = $(this);

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'down'){
					
					if(thisOne.parents('section').is(':first-child')){
						thisOne.addClass('animate');
					}else{
						setTimeout(function(){
							thisOne.addClass('animate');
						}, 200);
					}
				}
			},
			offset: '85%',
		});

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'up'){
					thisOne.removeClass('animate');
				}
			},
			offset: '100%'
		});
	});
}
//Waypoints END

//Waypoint.refreshAll();

//Scroll Menu START
var body = document.body;
var triggerMenu = document.querySelector(".page-header .trigger-menu");
var nav = document.querySelector(".page-header nav");
var menu = document.querySelector(".page-header .menu");
var scrollUp = "scroll-up";
var scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", function(e) {
  var currentScroll = window.pageYOffset;
  if (currentScroll < 100) {
	body.classList.remove(scrollUp);
	return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
	// down
	body.classList.remove(scrollUp);
	body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && currentScroll < 50 && body.classList.contains(scrollDown)) {
	// up and at top
	body.classList.remove(scrollDown);
	body.classList.remove(scrollUp);
	
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
	// up
	body.classList.remove(scrollDown);
	body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});
//Scroll Menu END

//console.log(myTheme);

$(window).ready(function() {
	//$('.pakery-grid').addClass('loading');

	$('#burger').click(function(){
		$(this).toggleClass('open');
		$(this).addClass('close');
		$('html').toggleClass('menu-open');
	});

	$('#filter').click(function(){
		$(this).toggleClass('open');
		$(this).addClass('close');
		$('html').toggleClass('filter-open');
	});

	$('li.menu-item-has-children').click(function(){
		$(this).toggleClass('open');
	});

	$('.main-menu li a').click(function(e){
		e.stopPropagation()
	});

	$('.main-menu li li').click(function(e){
		e.stopPropagation()
	});

	$('p:has(img)').css('margin-bottom','0').addClass('p-img');

	$('img.alignnone, img.alignright, img.alignleft, img.aligncenter ').each(function(){
		var thisOne = $(this);
		var thiswidth = thisOne.attr('width');

		thisOne.css('width', thiswidth/10 + 'rem')
	});


	// $('a').on('click', function (e) {
	// 	const href = $(this).attr('href');

	// 	// Check if href starts with 'pop-'
	// 	if (href && href.startsWith('pop-')) {
	// 		e.preventDefault(); // prevent the default link action

	// 		const selector = `.popup-con#${href}`;
	// 		const popup = $(selector);

	// 		if (popup.length) {
	// 			// Do something with the popup, e.g., show it
	// 			popup.show(); // or popup.addClass('active') etc.
	// 		} else {
	// 			console.warn('Popup not found:', selector);
	// 		}
	// 	}
	// });

	$('a[href^="#pop-"]').on('click', function(e){
		e.preventDefault();
		var thisOne = $(this);
		var thisPop = thisOne.attr('href');

		$('.popup-con').removeClass('open');
		$('.popup-con'+thisPop).addClass('open');
	});

	$('.popup-con .close').on('click', function(e){
		$('.popup-con').removeClass('open');
	});

	if ($('dl.accordion').length > 0) {
		
		$(document).on('click', 'dl.accordion dt', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			var ddH = thisOne.next('dd').find('.inner').outerHeight();
			thisOne.next('dd').css('maxHeight', ddH+'px');
			thisOne.addClass('open').find('i').find('span').text('close table');
	
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(document).on('click', 'dl.accordion dt.open', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.removeClass('open').find('i').find('span').text('open table');
			
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(window).resize(function() {
			$('dl.accordion dt.open').each(function(){
				var thisOne = $(this);
				var ddH = thisOne.next('dd').find('.inner').outerHeight();
				thisOne.next('dd').css('maxHeight', ddH+'px');
			});
		});
	}

	if ($('.menu-text-con').length > 0) {
		$('.menu-text-con').each(function() {
			var $thisOne = $(this);
			$('.main-menu > li.menu-item-has-children > .sub-menu').prepend($thisOne);
		});
	}

	// $('.video-con .play-video').on('click', function(){
	// 	var thisOne = $(this);
	// 	var video = thisOne.parent('.video-con').addClass('playing').find('video')
	// 	video.get(0).play()
	// });

	$(document).on('click', '.tabs .tab, .tab-head', function() {
		var thisOne = $(this);
		thisOne.parents('.tab-container').find('.tab-content, .tabs .tab, .tab-head').removeClass('active');
		var activeTab = $(this).attr("rel");
		console.log(activeTab);
		
		thisOne.parents('.tab-container').find('#'+activeTab).addClass('active');
		$(this).addClass('active');
		thisOne.parents('.tab-container').find('.tabs .tab[rel^='+activeTab+']').addClass('active');
		thisOne.parents('.tab-container').find('.tab-head[rel^='+activeTab+']').addClass('active');

		setTimeout(function(){
			Waypoint.refreshAll();
		}, 500);
	});

	$(document).on('change', '.range-filter-con .range-filter', function() {
		var thisOne = $(this);
		
		if (thisOne.val() != '#') {
			$('[data-child]').removeClass('show');
			$('[data-child="'+thisOne.val()+'"]').addClass('show');
		} else {
			$('[data-child]').removeClass('show');
		}

		setTimeout(function(){
			Waypoint.refreshAll();
		}, 500);
	});

	$('.btn[target="_blank"]').append('<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.75002 0.75V2.66667H9.9821L0.791687 11.8571L2.14294 13.2083L11.3334 4.01792V12.25H13.25V0.75H1.75002Z" fill="#1F3A63"/></svg>');


	$('.btn[href^="tel:"]').prepend('<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.965 8.56906C6.045 10.6916 7.785 12.4241 9.9075 13.5116L11.5575 11.8616C11.76 11.6591 12.06 11.5916 12.3225 11.6816C13.1625 11.9591 14.07 12.1091 15 12.1091C15.4125 12.1091 15.75 12.4466 15.75 12.8591V15.4766C15.75 15.8891 15.4125 16.2266 15 16.2266C7.9575 16.2266 2.25 10.5191 2.25 3.47656C2.25 3.06406 2.5875 2.72656 3 2.72656H5.625C6.0375 2.72656 6.375 3.06406 6.375 3.47656C6.375 4.41406 6.525 5.31406 6.8025 6.15406C6.885 6.41656 6.825 6.70906 6.615 6.91906L4.965 8.56906Z" fill="#1F3A63"/><defs><clipPath id="clip0_40000237_36973"><rect width="18" height="18" fill="white" transform="translate(0 0.476562)"/></clipPath></defs></svg>');

	$(document).on('click', '.next-section', function() {
		var thisOne = $(this);
		var target = thisOne.parent('section').next('section');

		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 200);
		return false;
		}
	});

	// $('.quantity').each(function() {
	// 	const $this = $(this);
	// 	const $input = $this.find('input[type="number"]');

	// 	// Add buttons if not already added
	// 	if (!$this.hasClass('buttons-added')) {
	// 		$this.addClass('buttons-added');
	// 		$input.before('<button type="button" class="minus">−</button>');
	// 		$input.after('<button type="button" class="plus">+</button>');
	// 	}
	// });

	// // Click handlers
	// $(document).on('click', '.plus, .minus', function() {
	// 	const $button = $(this);
	// 	const $input = $button.siblings('input.qty');
	// 	const currentVal = parseFloat($input.val());
	// 	const min = parseFloat($input.attr('min')) || 1;
	// 	const max = parseFloat($input.attr('max')) || Infinity;
	// 	const step = parseFloat($input.attr('step')) || 1;

	// 	let newVal = currentVal;

	// 	if ($button.hasClass('plus')) {
	// 		if (currentVal < max) {
	// 			newVal = currentVal + step;
	// 		}
	// 	} else {
	// 		if (currentVal > min) {
	// 			newVal = currentVal - step;
	// 		}
	// 	}

	// 	$input.val(newVal).trigger('change');
	// });

	function setActiveColour(value) {
		$('.variations-radio.colours button').removeClass('active');
		if (value) {
			$('.variations-radio.colours button#' + value).addClass('active');
		}
	}

	// Click on colour div → update select
	$('.variations-radio.colours button').on('click', function() {
		let selectedVal = $(this).attr('id');
		$('#pa_colours').val(selectedVal).trigger('change');
		setActiveColour(selectedVal);
	});

	// Change select → update divs
	$('#pa_colours').on('change', function() {
		let selectedVal = $(this).val();
		setActiveColour(selectedVal);
	});

	// On page load, check if select already has a value
	let initialVal = $('#pa_colours').val();
	setActiveColour(initialVal);

	$('.woocommerce-MyAccount-navigation li.is-active').on('click', function(){
		$(this).parent('ul').toggleClass('open');
	});

	$('.our-products-section [data-block]').on('mouseenter', function(){
		var thisOne = $(this);
		var thisBlock = thisOne.data('block');

		$('.our-products-section [data-image]').removeClass('active');
		$('.our-products-section [data-image="'+thisBlock+'"]').addClass('active');
	});

	const cartBlock = document.querySelector('[data-block-name="woocommerce/cart"]');

	if (cartBlock) {
		const observer = new MutationObserver((mutationsList, observer) => {
			// Check if any row was added or removed
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					Waypoint.refreshAll();
					break;
				}
			}
		});

		observer.observe(cartBlock, { childList: true, subtree: true });
	}

	// $('.footer-menu a').each(function() {
	// 	$(this).wrap('<span></span>');
	// });
});

//Lenis START
function lenisStart(){
	// Initialize Lenis
	const lenis = new Lenis({
		duration: 2,
		smooth: true,
		smoothTouch: true,
	});

	//lenis.on('scroll', ScrollTrigger.update);

	// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
	// This ensures Lenis's smooth scroll animation updates on each GSAP tick
	gsap.ticker.add((time) => {
		lenis.raf(time * 1000); // Convert time from seconds to milliseconds
	});

	// Disable lag smoothing in GSAP to prevent any delay in scroll animations
	gsap.ticker.lagSmoothing(0);

	const refresh = () => {
		ScrollTrigger.clearScrollMemory();
		window.history.scrollRestoration = 'manual';
		ScrollTrigger.refresh(true);
	}

	refresh();
	window.addEventListener('resize', refresh);
}
//Lenis END

$(window).on('load', function(){
	$('html').addClass('loaded');

	$('.form-section .gform_button.button').append('<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.423587 13.375L15.2915 7L0.423587 0.625L0.416504 5.58333L11.0415 7L0.416504 8.41667L0.423587 13.375Z" fill="white"/></svg>');

	$('.btn, .gform_button.button, .facetwp-reset, button.button, a.button, .wc-block-components-totals-coupon__button, .wc-block-components-checkout-return-to-cart-button').wrapInner('<span></span>');

	// Add plus and minus buttons
	$('.woocommerce .quantity').each(function() {
		let $this = $(this);

		// Prevent adding multiple times
		if (!$this.hasClass('buttons-added')) {
			$this.addClass('buttons-added');
			$this.prepend('<button type="button" class="minus">-</button>');
			$this.append('<button type="button" class="plus">+</button>');
		}
	});


	// Function to change value
	$(document).on('click', '.woocommerce .quantity .plus, .woocommerce .quantity .minus', function() {
		let $qty = $(this).closest('.quantity').find('input.qty'),
			currentVal = parseFloat($qty.val()),
			max = parseFloat($qty.attr('max')),
			min = parseFloat($qty.attr('min')),
			step = parseFloat($qty.attr('step'));

		// Fallbacks
		if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
		if (isNaN(max)) max = '';
		if (isNaN(min)) min = 0;
		if (isNaN(step) || step === '' || step === 'any') step = 1;

		if ($(this).hasClass('plus')) {
			if (max && currentVal >= max) {
				$qty.val(max);
			} else {
				$qty.val((currentVal + step).toFixed(step % 1 ? 1 : 0));
			}
		} else {
			if (currentVal <= min) {
				$qty.val(min);
			} else {
				$qty.val((currentVal - step).toFixed(step % 1 ? 1 : 0));
			}
		}

		$qty.trigger('change'); // Trigger WooCommerce update
	});

	$('.facetwp-type-pager').addClass('waypoint');

	jQuery(document).on('gform_page_loaded', function(event, form_id, current_page){
		$('.form-section .gform_button.button').append('<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.423587 13.375L15.2915 7L0.423587 0.625L0.416504 5.58333L11.0415 7L0.416504 8.41667L0.423587 13.375Z" fill="white"/></svg>');
		$('.gform_button.button').wrapInner('<span></span>');
	});

	gsap.registerPlugin(ScrollTrigger);

	lenisStart();

	setTimeout(function(){
		$(window).trigger('resize');

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
		}, 0);
	}, 0);

	setTimeout(function(){

		function globeSideLine() {

			var containers = gsap.utils.toArray(".side-line");

			containers.forEach(function (container) {
				gsap.fromTo(
					container.querySelectorAll(".side-line span"),
					{ 
						maxHeight: '0%'},
					{
						maxHeight: '100%',
						scrollTrigger: {
							trigger: container,
							scrub: 1,
							start: '0% 50%',
							end: "100% 50%",
							//markers: true
						}
					}
				);
			});
		}

		globeSideLine();

	}, 100);
	
	// const swiper = new Swiper('.-slide', {
	// 	loop: true,
	// 	spaceBetween: 0,
	// 	slidesPerView: 1,
	// 	preventInteractionOnTransition: true,
	// 	centerInsufficientSlides: true,
	// 	centeredSlides: false,
	// 	autoplay: {
	// 		delay: 3000,
	// 		disableOnInteraction: false,
	// 		pauseOnMouseEnter: true,
	// 	},
	// 	speed: 300,
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: 'bullets',
	// 		clickable: true,
	// 	},
	// 	scrollbar: {
	// 		el: '.swiper-scrollbar',
	// 		draggable: true,
	// 		hide: false,
	// 	},
	// 	breakpoints: {
	// 		769: {
	// 			centeredSlides: false,
	// 			spaceBetween: 0,
	// 			slidesPerView: 3,
	// 		},
	// 		1441: {
	// 			spaceBetween: 0,
	// 			slidesPerView: 4,
	// 		}
	// 	}
	// });

	const swiperH = new Swiper('.hero-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	const swiperPa = new Swiper('.partners-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 3,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 3000,
		breakpoints: {
			769: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 5,
				autoplay: false,
			},
		}
	});

	const swiperT = new Swiper('.testimonials-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: true,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			769: {
				centeredSlides: true,
				spaceBetween: 0,
				slidesPerView: 1.79,
			},
			992: {
				centeredSlides: true,
				spaceBetween: 0,
				slidesPerView: 3,
			},
		},
		// on: {
		// 	slideChangeTransitionStart: function () {
		// 		const prevSlide = this.el.querySelector('.swiper-slide-prev');
		// 		const nextSlide = this.el.querySelector('.swiper-slide-next');
		// 		if (prevSlide) {
		// 			const height = $(prevSlide).outerHeight();
		// 			const prevFade = this.el.querySelector('.prev');
		// 			$(prevFade).css('height', height + 'px');
		// 		}

		// 		if (nextSlide) {
		// 			const height = $(nextSlide).outerHeight();
		// 			const nextFade = this.el.querySelector('.next');
		// 			$(nextFade).css('height', height + 'px');
		// 		}
		// 	}
		// }
	});

	const swiperCa = new Swiper('.case-studies-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			769: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 2,
			},
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 4,
			},
		}
	});

	const swiperM = new Swiper('.more-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			769: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 2,
			},
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 4,
			},
		}
	});

	const swiperBl = new Swiper('.block-links-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 4,
			},
		}
	});

	const swiperTo = new Swiper('.top-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 2.04,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
		breakpoints: {
			769: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 4,
			},
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 3,
			},
		}
	});

const swiperWn = new Swiper('.why-nav-slide', {
	loop: false,
	spaceBetween: 0,
	slidesPerView: 'auto', // allow custom widths
	preventInteractionOnTransition: true,
	centerInsufficientSlides: true,
	centeredSlides: false,
	watchSlidesProgress: true,
	breakpoints: {
		992: {
			centeredSlides: false,
			spaceBetween: 0,
			slidesPerView: 'auto',
		}
	},
	on: {
		afterInit: function () {
			// wait one frame for Swiper to render DOM widths
			setTimeout(() => {
				$('.why-nav-slide .inner span').each(function() {

					const $span = $(this);
					const $inner = $span.closest('.inner');
					const $slide = $inner.closest('.swiper-slide');

					// use computed styles for accurate padding
					const styles = window.getComputedStyle($inner[0]);
					const paddingLeft = parseFloat(styles.paddingLeft) || 0;
					const paddingRight = parseFloat(styles.paddingRight) || 0;

					const spanWidth = $span.outerWidth(); // includes border/padding of the span
					const totalWidth = spanWidth + paddingLeft + paddingRight;

					// Apply both width and max-width
					$slide.css({
						width: totalWidth + 'px',
						maxWidth: totalWidth + 'px'
					});
				});

				// Tell Swiper to recalc sizes after width adjustments
				swiperWn.update();
			}, 0);
		}
	}
});

	const swiperW = new Swiper('.why-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		watchSlidesProgress: true,
		autoHeight: true,
		thumbs: {
			swiper: swiperWn,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		on:{ 
			slideChange: function() {
				waypoints();
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
	});

	const swiperP = new Swiper('.product-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		watchSlidesProgress: true,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
	});

	$('.product-nav button').on('click', function(){
		var thisOne = $(this);
		var thisSlide = thisOne.data('swiper-slide-index');

		$('.product-nav button').removeClass('active');
		thisOne.addClass('active');
		swiperP.slideToLoop(thisSlide);
	});

	// child and parent slides
	// swiperQ.controller.control = swiperQI;
	// swiperQI.controller.control = swiperQ;

	$('.swiper-wrapper').each(function(){
		$(this).parents('.swiper').css('overflow', 'visible');
		$(this).wrap('<div class="swiper-wrapper-con" style="overflow: hidden;"></div>');
	});

	$('.c-item .inner').matchHeight({ property: 'min-height' });

	$('.b-item .icon-con, .b-item .stat-con').matchHeight({ property: 'min-height' });

	$('.finance-case-studies-section .swiper-slide h3').matchHeight({ property: 'min-height' });
	$('.op-item h4').matchHeight({ property: 'min-height' });

	$('.text-area').fitVids();

	Fancybox.bind("[data-fancybox]", {
		Hash: false,
	});

	// 	function insertCartSVG() {
	// 	$('.wc-block-cart-item__image a').each(function() {
	// 	if (!$(this).find('svg.custom-cart-svg').length) {
	// 		$(this).prepend('shit');
	// 	}
	// 	});
	// }

	// // Observe when cart is rendered
	// const cartObserver = new MutationObserver(function(mutations, observer) {
	// 	const cartReady = document.querySelector('.wc-block-cart-items');
	// 	if (cartReady) {
	// 	insertCartSVG();
	// 	}
	// });

	// cartObserver.observe(document.body, {
	// 	childList: true,
	// 	subtree: true
	// });
	
	$('.range-filter-con').appendTo('.compare-our-range-section .filter-con');

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		
		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
		}, 0);
	});
	
	document.addEventListener('facetwp-loaded', function(event){

		if ($('.facetwp-count-current').length > 0) {
			const current = FWP.settings.pager.page * FWP.settings.pager.per_page;
			const total = FWP.settings.pager.total_rows;

			document.querySelector('.facetwp-count-current').innerText = Math.min(current, total);
			document.querySelector('.facetwp-count-total').innerText = total;
		}
		
		if(!$('.shop-archive-section .facetwp-search').val() == ''){
			$('.shop-archive-section .extra').addClass('show').find('p').find('span').text($('.shop-archive-section .facetwp-search').val());
		} else {
			$('.shop-archive-section .extra').removeClass('show').find('p').find('span').text('');
		}

		$('#filter').removeClass('open');
		$('#filter').addClass('close');
		$('html').removeClass('filter-open');

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
			$('.btn, .gform_button.button, .facetwp-reset, button.button, a.button, .wc-block-components-totals-coupon__button, .wc-block-components-checkout-return-to-cart-button').wrapInner('<span></span>');
			$('.c-item .inner').matchHeight({ property: 'min-height' });
			$('.op-item h4').matchHeight({ property: 'min-height' });

			$('.compare-our-range-section .filter-con .range-filter-con').remove();
			$('.range-filter-con').appendTo('.compare-our-range-section .filter-con');

		}, 0);
	});

	(function( $ ) {

		/**
		 * initMap
		 *
		 * Renders a Google Map onto the selected jQuery element
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @param   jQuery $el The jQuery element.
		 * @return  object The map instance.
		 */
		function initMap( $el ) {
	
			var stylers = [
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "geometry",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "administrative.province",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						},
						{
							"saturation": "-100"
						},
						{
							"lightness": "30"
						}
					]
				},
				{
					"featureType": "administrative.neighborhood",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						},
						{
							"gamma": "0.00"
						},
						{
							"lightness": "74"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "landscape.man_made",
					"elementType": "all",
					"stylers": [
						{
							"lightness": "3"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				}
			]
	
			// Find marker elements within map.
			var $markers = $el.find('.marker');
	
			// Create gerenic map.
			var mapArgs = {
				//styles		: stylers,
				mapTypeControl: false,
				//draggable: false,
				scaleControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				navigationControl: false,
				streetViewControl: false,
				zoom        : $el.data('zoom') || 16,
				mapTypeId   : google.maps.MapTypeId.ROADMAP
			};
			var map = new google.maps.Map( $el[0], mapArgs );
	
			// Add markers.
			map.markers = [];
			$markers.each(function(){
				initMarker( $(this), map );
			});
	
			// Center map based on markers.
			centerMap( map );
	
			// Return map instance.
			return map;
		}
	
		/**
		 * initMarker
		 *
		 * Creates a marker for the given jQuery element and map.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @param   jQuery $el The jQuery element.
		 * @param   object The map instance.
		 * @return  object The marker instance.
		 */
		function initMarker( $marker, map ) {
	
			// Get position from marker.
			var lat = $marker.data('lat');
			var lng = $marker.data('lng');
			var latLng = {
				lat: parseFloat( lat ),
				lng: parseFloat( lng )
			};
	
			const icon = {
				url: myTheme.theme_directory+"/assets/images/marker.svg", // url
				scaledSize: new google.maps.Size(82, 103), // scaled size
				origin: new google.maps.Point(0,0), // origin
				anchor: new google.maps.Point(41, 103) // anchor
			};
	
			// Create marker instance.
			var marker = new google.maps.Marker({
				position : latLng,
				//icon: icon,
				map: map
			});
	
			// Append to reference for later use.
			map.markers.push( marker );
	
			// If marker contains HTML, add it to an infoWindow.
			if( $marker.html() ){
	
				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});
	
				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open( map, marker );
				});
			}
		}
	
		/**
		 * centerMap
		 *
		 * Centers the map showing all markers in view.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @param   object The map instance.
		 * @return  void
		 */
		function centerMap( map ) {
	
			// Create map boundaries from all map markers.
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function( marker ){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});
	
			// Case: Single marker.
			if( map.markers.length == 1 ){
				map.setCenter( bounds.getCenter() );
	
			// Case: Multiple markers.
			} else{
				map.fitBounds( bounds );
			}
		}
	
		$('.acf-map').each(function(){
			var map = initMap( $(this) );
		});
	
	})(jQuery);

});